/**
 * @generated SignedSource<<d7e51a208692c1107b1d9f278c275151>>
 * @relayHash f896b23254971c6ead2752528971cc91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 93e64bba73832eb1d3c771694dc785e25a7245c40f51bb025976883534eb2782

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "93e64bba73832eb1d3c771694dc785e25a7245c40f51bb025976883534eb2782",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
